import { cmsConstants } from "../../../constants/cms/cms.constants";

const initialState = {
  editMode: true,
  containerToUpdate: null,
  containerAdded: null,
  fonts: [],
  showMergeAlert: false,
  mergeDescription: [],
  mergeSource: '',
  isSaving: false,
  inheritInfo: false,
  inheritageAffected: false,
  deselectionBlocked: false
};

export function cms(state = initialState, action) {
  switch (action.type) {
    case cmsConstants.LOAD_CLIENT_FONTS:
      return {
        ...state,
        fonts: action.fonts
      };
    case cmsConstants.REMOVE_CLIENT_FONT:
      const newFonts = Array.from(state.fonts);
      const index = state.fonts.indexOf(newFonts.find(f => { return f.name === action.font.name }));
      newFonts.splice(index, 1);
      return {
        ...state,
        fonts: newFonts
      };
    case cmsConstants.ALERT_NEW_MODIFICATIONS:

      return {
        ...state,
        mergeSource: !action.isModified ? [] : [...state.mergeSource, action.source],
        showMergeAlert: action.isModified,
        mergeCallback: action.isModified ? action.callback : null
      }
    case cmsConstants.BLOCK_DESELECT:
      return {
        ...state,
        deselectionBlocked: action.isBlocked
      };
    case cmsConstants.GLOBAL_SAVING_LOADER:
      return {
        ...state,
        isSaving: action.isLoading
      };
    case cmsConstants.INHERITAGE_AFFECTED:
      return {
        ...state,
        inheritageAffected: action.isAffected
      };
    case cmsConstants.TOGGLE_INHERITAGE_INFO:
      return {
        ...state,
        inheritInfo: action.on
      };
    case cmsConstants.ADD_CLIENT_FONT:
      return {
        ...state,
        fonts: [...state.fonts, action.font]
      };
    case cmsConstants.SET_SOURCE_LOCATION:
      return {
        ...state,
        sourceLocation: action.sourceLoc,
        sourceEnviroment: action.env
      };
    case cmsConstants.SET_ENVIROMENT:
      return {
        ...state,
        enviroment: action.env,
        editMode: action.editMode,
        eventId: action.eventId
      };
    case cmsConstants.CONTAINER_TO_UPDATE:
      return {
        ...state,
        containerToUpdate: action.container
      };
    case cmsConstants.CONTAINER_UPDATED:
      return {
        ...state,
        containerToUpdate: null
      };
    case cmsConstants.CONTAINER_ADDED:
      return {
        ...state,
        containerAdded: action.container
      };
    default:
      return state;
  }
}
